import CardExpiryService from '../payment/CardExpiryService';
import MvcField from './MvcField';
import PaymentFieldType from './PaymentFieldType';
import ValidationResult from './ValidationResult';

export default class MvcValidationService {
    constructor(private readonly paymentForm: JQuery<HTMLFormElement>) {
    }

    public validate(): ValidationResult[] {
        const validationResult: ValidationResult[] = [];
        const fullName = this.paymentForm.find('#CardHolderName');
        const cardExpiry = this.paymentForm.find('#CardExpiry');
        const cardExpiryService = new CardExpiryService();
        const isCardHolderAddressRequired = document.querySelector(`.card-holder-address-form`) !== null;
        const country = this.paymentForm.find('#CardHolderCountry');
        const address = this.paymentForm.find('#CardHolderAddress');
        const city = this.paymentForm.find('#CardHolderCity');
        const postalCode = this.paymentForm.find('#CardHolderPostalCode');
        const isExcepted = (document.querySelector(`.spreedly[data-excepted-card]`)?.getAttribute('data-excepted-card') ?? "false") == "true";

        if (fullName[0] && !fullName.val())
        {
            validationResult.push({
                PaymentFieldType: PaymentFieldType.cardholdername,
                ErrorMessage: fullName.data('value-missing')
            });
        }
        if (cardExpiry[0] && !cardExpiry.val()) {
            validationResult.push({
                PaymentFieldType: PaymentFieldType.cardexpiry,
                ErrorMessage: cardExpiry.data('value-missing')
            });
        } else {
            cardExpiryService.createCardExpiry(cardExpiry.val() as string);
            if (!cardExpiryService.isValid || cardExpiryService.isExpired) {
                validationResult.push({
                    PaymentFieldType: PaymentFieldType.cardexpiry,
                    ErrorMessage: cardExpiryService.errorMessage
                });
            }
        }

        if (!isCardHolderAddressRequired || isExcepted) {
            return validationResult;
        }

        if (country[0] && !country.val()) {
            validationResult.push({
                PaymentFieldType: PaymentFieldType.cardholdercountry,
                ErrorMessage: country.data('value-missing')
            });
        }
        if (address[0] && !address.val()) {
            validationResult.push({
                PaymentFieldType: PaymentFieldType.cardholderaddress,
                ErrorMessage: address.data('value-missing')
            });
        }
        if (city[0] && !city.val()) {
            validationResult.push({
                PaymentFieldType: PaymentFieldType.cardholdercity,
                ErrorMessage: city.data('value-missing')
            });
        }
        if (postalCode[0] && !postalCode.val()) {
            validationResult.push({
                PaymentFieldType: PaymentFieldType.cardholderpostalcode,
                ErrorMessage: postalCode.data('value-missing')
            });
        }

        return validationResult;
    }

    public handleIFrameFieldsEvent(mvcFields: MvcField[]) {
        mvcFields.forEach(mvcField => {
            const field = this.paymentForm.find(`#${mvcField.id}`);
            field.on('change', () => {
                const validationResult = this.validate().find(
                    result => result.PaymentFieldType === mvcField.type,
                );
                mvcField.validationErrorMessage = validationResult ? validationResult.ErrorMessage : '';
                mvcField.renderErrorMessage();
            });
        });
    }
}
